import axios from "axios";
import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

import ReactSelect from "react-select";
import SuccessModal from "../modal/SuccessModal";

const ContactForm = () => {
  const [showEmailError, setShowEmailError] = useState(false);
  const [showNameError, setShowNameError] = useState(false);
  const [showSubjectError, setShowSubjectError] = useState(false);
  const [showRemarkError, setShowRemarkError] = useState(false);
  const [btnText, setBtnText] = useState("Submit");
  const [show, setShow] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject]: any = useState([]);
  const [remarks, setRemarks] = useState("");

  const remarkOptions: any = [
    { value: "General", label: "General" },
    { value: "PR", label: "PR" },
    { value: "Sales", label: "Sales" },
  ];

  const handleChangeSubjct = (selected: any) => {
    if (selected) {
      setSubject(selected);
      setShowSubjectError(false);
    }
    if (selected.value) {
      setShowSubjectError(false);
    } else {
      setShowSubjectError(true);
    }
  };
  async function submitForm(e: any) {
    e.preventDefault();
    if (name && email && subject && remarks) {
      try {
        setBtnText("Submitting...");
        let url =
          process.env.NEXT_PUBLIC_DUNCAN_TAYLOR_API_URL +
          "/api/contact-us/save";

        const response = await axios
          .post(url, {
            data: {
              name: `${name}`,
              email: `${email}`,
              subject: `${subject.value}`,
              message: `${remarks}`,
            },
          })
          .then((res: any) => {
            if (res.status == 200) {
              setShow(true);
            }
          });
        setName("");
        setEmail("");
        setSubject(null);
        setRemarks("");
        setBtnText("Submit");
      } catch (error: any) {
        console.log("err", error);
      }
    } else {
      if (name) {
        setShowNameError(false);
      } else {
        setShowNameError(true);
      }
      if (email) {
        setShowEmailError(false);
      } else {
        setShowEmailError(true);
      }
      if (remarks) {
        setShowRemarkError(false);
      } else {
        setShowRemarkError(true);
      }
      if (subject.length > 0) {
        setShowSubjectError(false);
      } else {
        setShowSubjectError(true);
      }
    }
  }
  return (
    <Container>
      <Row>
        <Col md={12} xs={12}>
          <div className="contact-form-outerwrapper">
            <div
              className="contact-form-wrapper"
              style={{
                backgroundImage: `url(/images/contact-us-bg.png)`,
              }}
            >
              <h3 className="headingText">How Can we help you?</h3>
              {/* <p className="subheadingText">
                If you have a question, feedback or would like to know more
                about us and our products, please get in touch.
              </p> */}
              <form className="contact-form w-100" onSubmit={submitForm}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group-wrapper">
                      <div className="form-group">
                        <label htmlFor="name">
                          Your name<span>*</span>
                        </label>
                        <input
                          className="font-beausite-trialthin"
                          type="text"
                          placeholder=""
                          id="name"
                          name="name"
                          value={name}
                          onChange={(e: any) => {
                            const enteredValue = e.target.value;
                            setName(enteredValue);
                            if (enteredValue.trim().length > 0) {
                              setShowNameError(false);
                            } else {
                              setShowNameError(true);
                            }
                          }}
                        />
                      </div>
                      {showNameError && (
                        <span className="showerror showsignuperror">Enter Name</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group-wrapper">
                      <div className="form-group">
                        <label
                          className="font-beausite-trialthin"
                          htmlFor="email"
                        >
                          Your email address<span>*</span>
                        </label>
                        <input
                          type="email"
                          placeholder=""
                          id="email"
                          name="email"
                          value={email}
                          onChange={(e) => {
                            const enteredValue = e.target.value;
                            setEmail(enteredValue);
                            // Check if the entered value is not empty
                            if (enteredValue.trim().length > 0) {
                              setShowEmailError(false);
                            } else {
                              setShowEmailError(true);
                            }
                          }}
                        />
                      </div>
                      {showEmailError && (
                        <span className="showerror showsignuperror">Enter Email Id</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group-wrapper">
                      <div className="form-group">
                        <label
                          className="font-beausite-trialthin"
                          htmlFor="mobile"
                        >
                          Subject<span>*</span>
                        </label>
                        <ReactSelect
                          value={subject}
                          onChange={handleChangeSubjct}
                          options={remarkOptions}
                          classNamePrefix="react-select"
                          // onchangeHandler={prefilledCityValue}
                          placeholder={"General"}
                        />
                      </div>
                      {showSubjectError && subject.length == 0 && (
                        <span className="showerror showsignuperror">Select Zone</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group-wrapper">
                      <div className="form-group">
                        <label
                          className="font-beausite-trialthin"
                          htmlFor="namemessage"
                        >
                          Leave us a message<span>*</span>
                        </label>
                        <textarea
                          id="message"
                          name="message"
                          rows={3}
                          cols={12}
                          value={remarks}
                          onChange={(e) => {
                            const enteredValue = e.target.value;
                            setRemarks(enteredValue);
                            if (enteredValue.trim().length > 0) {
                              setShowRemarkError(false);
                            } else {
                              setShowRemarkError(true);
                            }
                          }}
                        ></textarea>
                      </div>
                      {showRemarkError && (
                        <span className="showerror showsignuperror">Enter your message</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="contact-form__btn">
                  <button className="btn btn-primary">{btnText}</button>
                </div>
              </form>
              <SuccessModal
                show={show}
                setShow={setShow}
                modalText={`Thank you. Your enquiry has been received and we will get back to you as soon as possible.`}
              />
            </div>
            <h6 className="bottom-headingText">
              We promise to never share your information.
            </h6>
            <p className="bottom-headingsubText">
              You can learn more about how we intend to use your data in our
              privacy policy.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactForm;
